import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Drawer from '@material-ui/core/Drawer';

import { Box, Flex, Image, SvgIcon, Text } from 'Components/Base';

const MenuHeaderWrapper = (props) => <Flex px={4} alignItems={'center'} {...props} />;

const ImageProfile = styled(Image)`
  border-radius: 100%;
  width: 40px;
  height: 40px;
`;

const MenuWrapper = styled((props) => <Flex p={4} alignItems={'center'} {...props} />)`
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryLighter};
  }
`;

const Divider = styled(Box)`
  ${({ theme: { colors } }) => css`
    border: 1px solid ${colors.bsGrays.gray200};
  `}
`;

const SidebarWithIcon = ({
  appVersion,
  displayName,
  imageProfileUrl,
  menuItems,
  onClose,
  open,
  phoneNo,
  workTime,
}) => {
  return (
    <Drawer open={open} onClose={onClose}>
      <Box py={8} width={'calc(6 / 7 * 100vw)'} maxWidth={'375px'}>
        <MenuHeaderWrapper>
          <ImageProfile
            src={
              imageProfileUrl && imageProfileUrl !== null
                ? imageProfileUrl
                : '/assets/images/classroom/userAvatar.svg'
            }
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = '/assets/images/classroom/userAvatar.svg';
            }}
          />
          <Text ml={4}>{displayName}</Text>
        </MenuHeaderWrapper>
        <Box mt={4}>
          {menuItems.map((menu, index) => {
            if (menu.key === 'divider') {
              return <Divider />;
            }
            return (
              <MenuWrapper onClick={menu.onClick} key={`${menu.text}-${index}`}>
                <SvgIcon icon={menu.icon} color={'primary'} size={24} />
                <Text ml={3}>{menu.text}</Text>
              </MenuWrapper>
            );
          })}
        </Box>
        <Divider />
        {phoneNo && (
          <Flex mt={5} px={4} alignItems={'flex-start'}>
            <SvgIcon icon={SvgIcon.ICON_LIST.PHONE} color={'primary'} size={24} />
            <Text textStyle={'caption'} fontWeight={'normal'} ml={3}>
              ติดต่อ Call center: {phoneNo}
              <br />
              (เวลาทำการ {workTime})
            </Text>
          </Flex>
        )}
        {appVersion && (
          <Flex mt={5} px={4} alignItems={'flex-start'}>
            <Box pl={6} />
            <Text textStyle={'caption'} fontWeight={'normal'} ml={3}>
              Version {appVersion}
            </Text>
          </Flex>
        )}
      </Box>
    </Drawer>
  );
};

SidebarWithIcon.propsTypes = {
  imageProfileUrl: PropTypes.string,
  appVersion: PropTypes.string,
  displayName: PropTypes.string,
  menuItems: PropTypes.shape({
    key: PropTypes.string,
    icon: PropTypes.object,
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  onClose: PropTypes.func,
  open: PropTypes.func,
  phoneNo: PropTypes.string,
  workTime: PropTypes.string,
};

export default SidebarWithIcon;
